import ProductListPopupCellRenderer from './ProductListMenu/ProductListMenu';
import {
  dateFormat,
  preorderDateFormat,
} from '../../common/Grid/GridUtilities';
import ChecklistFilter from '../../common/Grid/ChecklistFilter/ChecklistFilter';
import FormatTypeRenderer from './FormatTypeRenderer';
import AlbumStateRenderer from './AlbumStateRenderer';
import TitleVersionRenderer from './TitleVersionRenderer';
import PackagingRenderer from './PackagingRenderer';
import { TranslatableColDef } from '../../common/Grid/TranslatableColDef';
import { translatePhysicalProductType } from '@/helpers/translateProductType';

const overflowCellStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const productListColDef: TranslatableColDef[] = [
  {
    field: 'id',
    headerName: 'id',
    hide: true,
    cellStyle: overflowCellStyle,
    suppressColumnsToolPanel: true,
  },
  {
    field: 'updatedAt',
    headerName: 'Updated At',
    hide: true,
    sort: 'desc',
    cellStyle: overflowCellStyle,
    suppressColumnsToolPanel: true,
  },
  {
    field: 'format',
    tooltipValueGetter: (props) =>
      translatePhysicalProductType(props.data.format.name),
    headerName: 'Format',
    headerNameTranslationKey: 'product.editProduct.format',
    sortable: true,
    resizable: true,
    filter: ChecklistFilter,
    suppressHeaderMenuButton: false,
    cellRenderer: FormatTypeRenderer,
    cellClass: 'grid-badge',
    flex: 2,
    maxWidth: 180,
  },
  {
    field: 'title',
    tooltipField: 'title',
    headerName: 'Title',
    headerNameTranslationKey: 'product.editProduct.title',
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    cellRenderer: TitleVersionRenderer,
    cellStyle: overflowCellStyle,
    flex: 3,
  },
  {
    field: 'packaging',
    tooltipField: 'packaging',
    headerName: 'Packaging',
    headerNameTranslationKey: 'product.editProduct.packaging',
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    cellRenderer: PackagingRenderer,
    cellStyle: overflowCellStyle,
    flex: 2,
  },
  {
    field: 'displayArtist',
    tooltipField: 'displayArtist',
    headerName: 'Display Artist',
    headerNameTranslationKey: 'product.editProduct.displayArtist',
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    cellStyle: overflowCellStyle,
    flex: 3,
  },
  {
    field: 'labelName',
    tooltipField: 'labelName',
    headerName: 'Label',
    headerNameTranslationKey: 'product.editProduct.labelname',
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    cellStyle: overflowCellStyle,
    flex: 2,
  },
  {
    field: 'releaseDate',
    tooltipField: 'releaseDate',
    headerName: 'Release Date',
    headerNameTranslationKey: 'product.editProduct.releaseDate',
    sortable: true,
    resizable: true,
    filter: 'agDateColumnFilter',
    valueFormatter: dateFormat,
    cellStyle: overflowCellStyle,
    flex: 2,
  },
  {
    field: 'gtin',
    tooltipField: 'gtin',
    headerName: 'UPC',
    headerNameTranslationKey: 'product.editProduct.GTIN',
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    cellStyle: overflowCellStyle,
    flex: 2,
  },
  {
    field: 'originalReleaseDate',
    initialHide: true,
    tooltipField: 'originalReleaseDate',
    headerName: 'Original Release Date',
    headerNameTranslationKey: 'product.editProduct.originalReleaseDate',
    sortable: true,
    resizable: true,
    filter: 'agDateColumnFilter',
    valueFormatter: dateFormat,
    cellStyle: overflowCellStyle,
    flex: 2,
  },
  {
    field: 'preOrderDate',
    initialHide: true,
    tooltipField: 'preOrderDate',
    headerName: 'Pre-Order Date',
    headerNameTranslationKey: 'product.editProduct.preOrderDate',
    sortable: true,
    resizable: true,
    filter: 'agDateColumnFilter',
    valueFormatter: preorderDateFormat,
    cellStyle: overflowCellStyle,
    flex: 2,
  },
  {
    field: 'priceCode',
    tooltipField: 'priceCode',
    headerName: 'Price Code',
    headerNameTranslationKey: 'product.editProduct.priceCode',
    sortable: false,
    resizable: true,
    cellStyle: overflowCellStyle,
    flex: 1.5,
  },
  {
    field: 'catalogNumber',
    tooltipField: 'catalogNumber',
    headerName: 'Catalog #',
    headerNameTranslationKey: 'product.editProduct.catalogNumber',
    sortable: true,
    resizable: true,
    cellStyle: overflowCellStyle,
    flex: 2,
  },
  {
    field: 'trackCount',
    tooltipField: 'trackCount',
    headerName: 'Tracks',
    headerNameTranslationKey: 'track.tracks',
    sortable: false,
    resizable: true,
    cellStyle: overflowCellStyle,
    flex: 1.1,
  },
  {
    field: 'albumState',
    tooltipField: 'albumState',
    headerName: 'Status',
    headerNameTranslationKey: 'product.editProduct.albumState',
    sortable: true,
    resizable: true,
    filter: ChecklistFilter,
    suppressHeaderMenuButton: false,
    cellRenderer: AlbumStateRenderer,
    cellClass: 'grid-badge',
    flex: 2,
    minWidth: 140,
  },
  {
    field: 'releaseType',
    tooltipField: 'releaseType',
    headerName: 'ReleaseType',
    headerNameTranslationKey: 'product.editProduct.releaseType',
    sortable: false,
    resizable: true,
    filter: 'agTextColumnFilter',
    cellStyle: overflowCellStyle,
    flex: 3,
    initialHide: true,
  },
  {
    field: 'videoContentType',
    tooltipField: 'videoContentType',
    headerName: 'VideoContentType',
    headerNameTranslationKey: 'product.editProduct.videoContentType',
    sortable: false,
    resizable: true,
    filter: 'agTextColumnFilter',
    cellStyle: overflowCellStyle,
    flex: 3,
    initialHide: true,
  },
  {
    width: 36,
    headerName: ' ',
    field: 'action',
    cellRenderer: ProductListPopupCellRenderer,
    cellClass: 'action-menu-cell',
    suppressColumnsToolPanel: true,
    resizable: false,
    suppressMovable: true,
  },
];
